export function isElementInFourthQuartile(position: number, total: number) {
  return Math.floor(total * 0.97) === position;
}
